import { render, staticRenderFns } from "./Caps.vue?vue&type=template&id=20b56ae2"
import script from "./Caps.vue?vue&type=script&lang=js"
export * from "./Caps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports